import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "../dfp-component";
import { appendGoogleTagServices } from "../utils";

import "./out-of-page-ad.m.css";

export const OutOfPageAd = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});
  const enableAds = get(adsConfig, ["enable_ads"], null);
  const loadAdsSynchronously = get(adsConfig, ["load_ads_synchronously"], null);
  const currentPath = get(qtState, ["currentPath"], null);
  const adSlots = get(qtState, ["config", "ads-config", "slots"], {});
  const delayAdScript = get(adsConfig, ["delay_ad_script"], 3);

  useEffect(() => {
    if (enableAds && !loadAdsSynchronously) {
      setTimeout(function () {
        appendGoogleTagServices();
      }, delayAdScript * 1000);
    }
  }, []);

  useEffect(() => {
    if (window.googletag && window.googletag.apiReady) {
      // check if the API is ready
      window.googletag.cmd.push(function () {
        if (window.googletag.pubadsReady) {
          // detect whether PubAdsService is fully loaded
          window.googletag.pubads().refresh();
        }
      });
    }
  }, [currentPath]);

  return (
    <DfpComponent
      adStyleName=""
      className="out-of-page-ad"
      id="out-of-page-ad-id"
      path={adSlots.site_take_over.ad_unit}
      size={adSlots.site_take_over.sizes}
      viewPortSizeMapping={adSlots.site_take_over.view_port_size_mapping}
    />
  );
};
